import {
  AutoComplete,
  Button,
  Dropdown,
  Form,
  Input,
  InputNumber,
  Modal,
  PaginationProps,
  Select,
  Space,
  Table,
  message,
  notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { columnsModal, resultOptionAnalysis } from "./ModalResults.config";
import Icons from "assets/icons";
import TableInputAdd from "components/common/TableInputAdd/TableInputAdd";
import { analysisService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setCallApi } from "redux/reducer/reduxCommon";
import moment from "moment";
import { FORMAT_TIME } from "types/enums";
import Notification from "components/common/notification/notification";

interface DataType {
  key: number;
}

const ModalResults = ({
  isShowModal,
  handleOk,
  handleCancel,
  detailRecord,
}) => {
  const [dataModal, setDataModal] = useState([]);
  const [userSubmit, setUserSubmit] = useState("ThS Đậu Trung Hiếu");
  const [formData] = Form.useForm();
  const [listCS, setListCS] = useState([]);
  const idChiDinhXN = useAppSelector((state) => state.reduxCommon.id2);
  const idChiDinhKQXN = useAppSelector((state) => state.reduxCommon.IdKQXN);
  const nguoiNhapKetQua = useAppSelector(
    (state) => state.reduxCommon.valueInput
  );
  const dispatch = useAppDispatch();

  const onFinish = async (value) => {
    // console.log("value", value);
    const newData = {
      id: detailRecord?.id,
      nguoiNhapKetQua: nguoiNhapKetQua,
      ketQuaChiSoXetNghiemDto: value.formTable,
    };
    // console.log('data put', newData);
    await saveResult(newData);
    dispatch(setCallApi());
    handleCancel();
  };

  const saveResult = async (body) => {
    try {
      const response = await analysisService
        .saveResult(detailRecord?.id, body)
        .then((res) => {
          Notification("success", "Lưu thành công");
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lưu");
    }
    // getResultAnalysis();
    getDataCS();
  };

  formData.setFieldsValue({
    formTable: dataModal,
    nameDoctor: userSubmit,
  });

  useEffect(() => {
    if (isShowModal) {
      getResultAnalysis();
      getDataCS();
      handleOnGetListById();
    }
  }, [isShowModal, detailRecord?.id, idChiDinhKQXN]);

  const getResultAnalysis = async () => {
    // console.log("dsadasdasdas", idChiDinhKQXN);
    try {
      const response = await analysisService
        .getListResult(idChiDinhKQXN)
        .then((res) => {
          const data = res.data.data.map((item) => ({
            id: item.id,
            // key: item.id,
            idChiDinhXetNghiem: item.idChiDinhXetNghiem,
            idChiSoXetNghiem: item.idChiSoXetNghiem,
            tenChiSoXetNghiem: item.tenChiSoXetNghiem,
            giaTri: item.giaTri,
            giaTriBinhThuong: item.giaTriBinhThuong,
            donViTinh: item.donViTinh,
            lanChay: item.lanChay,
          }));
          // if(!data.length) {
          //   getDataCS();
          // }
          // else {
          setDataModal(data);
          // }
        });
    } catch (error) {
      // Notification(
      //   "error",
      //   "Đã có lỗi xảy ra khi lấy danh sách kết quả xét nghiệm"
      // );
    }
  };

  useEffect(() => {
    formData.setFieldsValue({
      formTable: dataModal,
    });
  }, [dataModal]);

  const handleOnSubmit = async () => {
    const data = {
      id: idChiDinhXN,
      nguoiDuyetKetQua: userSubmit,
      thoiGianTraKetQua: moment().format(),
    };
    try {
      const response = await analysisService
        .submitAnalysisResult(data)
        .then((res) => {
          Notification("success", "Duyệt thành công");
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi duyệt");
    }
    handleCancel();
    // getResultAnalysis();
    // getDataCS();
  };

  columnsModal.map((record) => {
    if (record.dataIndex == "tenChiSoXetNghiem") {
      record.render = (value, record, index) => (
        <Form.Item>
          <Select
            style={{ width: "100%" }}
            options={listCS}
            value={value}
            onChange={(value, options) => handleOnSelect(value, options, index)}
          ></Select>
        </Form.Item>
      );
    }
    if (record.dataIndex == "lanChay") {
      record.render = (value, record, index) => (
        <Form.Item>
          <InputNumber
            style={{ width: "100%" }}
            value={value}
            onChange={(value) => {
              setDataModal((pre) => {
                return pre.map((preItem, ind) =>
                  ind == index
                    ? {
                        ...preItem,
                        lanChay: value,
                      }
                    : preItem
                );
              });
            }}
          ></InputNumber>
        </Form.Item>
      );
    }
    if (record.dataIndex == "giaTri") {
      record.render = (value, record: any, index) => (
        <Form.Item>
          <AutoComplete
            options={checkResultOption(record.tenChiSoXetNghiem)}
            style={{ width: "100%" }}
            value={value}
            onChange={(value) => {
              setDataModal((pre) => {
                return pre.map((preItem, ind) =>
                  ind == index
                    ? {
                        ...preItem,
                        giaTri: value,
                      }
                    : preItem
                );
              });
            }}
          ></AutoComplete>
        </Form.Item>
      );
    }
  });

  const handleOnSelect = (value, options, index) => {
    setDataModal((pre) => {
      return pre.map((preItem, ind) =>
        ind == index
          ? {
              ...preItem,
              idChiSoXetNghiem: options.id,
              idChiDinhXetNghiem: detailRecord?.id,
              donViTinh: options.donViTinh,
              giaTriBinhThuong: options.chiSoBinhThuong,
              tenChiSoXetNghiem: options.value,
            }
          : preItem
      );
    });
  };

  const checkResultOption = (name) => {
    const resultOption = resultOptionAnalysis.find(
      (option) => option.name === name
    );
    if (resultOption) {
      return resultOption.option;
    } else {
      return null;
    }
  };

  const getDataCS = async () => {
    try {
      const res = await analysisService.getListCategoryIndexAnalysis();
      // console.log("list chỉ số all", res);
      const newData = res.data.map((item) => ({
        id: item.id,
        key: item.id,
        label: item.maMayXetNghiem,
        value: item.tenChiSo,
        donViTinh: item.donViTinh,
        chiSoBinhThuong: item.chiSoBinhThuong,
      }));
      // const newDataModal = res.data.map((item) => ({
      //   key: item.id,
      //   id: 0,
      //   tenChiSoXetNghiem: item.tenChiSo,
      //   donViTinh: item.donViTinh,
      //   giaTriBinhThuong: item.chiSoBinhThuong,
      //   idChiSoXetNghiem: item.id,
      //   idChiDinhXetNghiem: idChiDinhXN,
      // }));
      setListCS(newData);
      // setDataModal(newDataModal)
    } catch (error) {
      message.error("Đã xảy ra lỗi khi lấy danh sách chỉ số");
    }
  };

  const handleOnGetListById = async () => {
    try {
      const res = await analysisService.getListCategoryIndexById(idChiDinhXN);
      // console.log("list chỉ số theo id", res);
      const newData = res.data.map((item) => ({
        id: item.id,
        label: item.maMayXetNghiem,
        value: item.tenChiSo,
        donViTinh: item.donViTinh,
        chiSoBinhThuong: item.chiSoBinhThuong,
      }));
      // const newDataModal = res.data.map((item) => ({
      //   key: item.id,
      //   id: 0,
      //   tenChiSoXetNghiem: item.tenChiSo,
      //   donViTinh: item.donViTinh,
      //   giaTriBinhThuong: item.chiSoBinhThuong,
      //   idChiSoXetNghiem: item.id,
      //   idChiDinhXetNghiem: idChiDinhXN,
      // }));
      // setListCS(newData);
      // setDataModal(newDataModal)
    } catch (error) {
      message.error("Đã xảy ra lỗi khi lấy danh sách chỉ số theo phiếu");
    }
  };

  // const onChange: PaginationProps["onChange"] = (page, pageSize) => {
  //   handleOnGetListById();
  // };

  return (
    <Modal
      title="Kết quả xét nghiệm"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={"80%"}
      className="modal-tab-pay"
      footer=""
    >
      <div className="table-results">
        <Form form={formData} onFinish={onFinish}>
          <Form.Item name={"formTable"}>
            <TableInputAdd
              data={dataModal}
              column={columnsModal}
              setData={setDataModal}
              pagination={false}
              // pagination={{
              //   position: ["bottomRight"],
              //   showSizeChanger: true,
              //   onChange: onChange,
              // }}
            ></TableInputAdd>
          </Form.Item>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "16px",
            }}
          >
            <Space>
              <span style={{ paddingRight: "30px" }}>Bác sĩ duyệt</span>
              <Input
                placeholder="Nhập"
                value={userSubmit}
                style={{ width: "203px" }}
                onChange={(e) => {
                  let value = e.target.value;
                  setUserSubmit(value);
                }}
              />
            </Space>
            <div>
              <Space>
                {/* <Button
                  type="ghost"
                  className="btn-sub"
                  onClick={handleOnGetListById}
                >
                  Lấy các chỉ số theo XN
                </Button> */}
                <Button
                  key="cancel"
                  type="primary"
                  danger
                  onClick={handleCancel}
                >
                  Huỷ bỏ
                </Button>
                <Form.Item>
                  <Button key="submit" type="primary" htmlType="submit">
                    Lưu lại
                  </Button>
                </Form.Item>
                <Button type="primary" onClick={handleOnSubmit}>
                  Duyệt
                </Button>
              </Space>
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default ModalResults;
